import React from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
// import './Login.css'
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";
import { loginAdmin } from "../../redux/AdminReducer";

import { loginDriver } from "../../redux/DriverReducer";

import { loginCustomer } from "../../redux/CustomerReducer";
const AdminLogin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [user, setUser] = useState({
    email: "",
    password: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setUser({
      ...user,
      [name]: value,
    });
  };

  const loginClicked = async () => {
    console.log("Clicked");

    const response = await dispatch(loginAdmin(user));

    console.log("Adminresponse",response?.payload?.response?.data?.message)
    if (response.payload.status) {
      Swal.fire("Good", response?.payload?.message, "success");

      navigate("/admin/dashboard");
    }
    if(response?.payload?.response?.data?.message)
    {
      Swal.fire("Error", response?.payload?.response?.data?.message, "error");

      // navigate("/admin/dashboard");
    }
  };

  return (
    <>
      <div className="mainContainerLogin">
        <div className="userLoginTxt">Admin Login</div>

        <div className="topInputFieldLogin">
          <div className="inputTxtLogin">Email</div>
          <input
            className="inputLogins"
            type="email"
            onChange={handleChange}
            name="email"
            placeholder="Enter Email"
          />
        </div>
        <div className="topInputFieldLogin">
          <div className="inputTxtLogin">Password</div>
          <input
            className="inputLogins"
            onChange={handleChange}
            name="password"
            type="password"
            placeholder="Enter Password"
          />
        </div>
        {/* <div className="forgotPassTxt">Forgot password?</div> */}

        <button className="loginBtn" onClick={() => loginClicked()}>
          Login
        </button>
      </div>
    </>
  );
};

export default AdminLogin;
